// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__u1cPZ","content":"styles_content__3-5M5","checkbox":"styles_checkbox__iNFHi","checkboxLabel":"styles_checkboxLabel__2u4hU"};